module.exports = __webpack_public_path__ + "img/be20a72.jpg";